import { TituloInterface } from './../../../models/titulo.model';
import { Component, inject, signal, ViewChild } from '@angular/core';
import { CrudEditComponent } from '../../../shared/components/crud/edit/edit.component';
import { ActivatedRoute } from '@angular/router';
import { TITULOS_FIELDS_FORM } from '../../../constants/titulos.constants';
import { TituloService } from '../../../core/titulo.service';
import { CaracterService } from '../../../core/caracter.service';
import { NivelService } from '../../../core/nivel.service';
import { defaultPaginateSelects } from '../../../utils/paginate.utils';

@Component({
  selector: 'app-titulos-edit',
  imports: [CrudEditComponent],
  templateUrl: './edit.html',
  styleUrl: './edit.scss'
})
export class TitulosEditComponent {
  id = signal('');
  fields = TITULOS_FIELDS_FORM
  tituloService = inject(TituloService);
  caracterService = inject(CaracterService);
  nivelService = inject(NivelService);
  titulo !: TituloInterface
  private activatedRoute = inject(ActivatedRoute);
  private subscriptions: any[] = [];
  private subCaracter: any = null;
  @ViewChild('editTitulo') editComponente!: CrudEditComponent<TituloInterface>;
  constructor() {
    // Access route parameters
    this.activatedRoute.params.subscribe((params) => {
      this.id.set(params['id']);
    });
  }
  ngOnInit() {
    this.tituloService.getById(Number(this.id())).subscribe((data) => {
      this.titulo = <TituloInterface>data;
      // Suscripción a caracterService
      if(this.titulo){
        const subCaracter = this.caracterService.getAllForSelect({
          ...defaultPaginateSelects,
          mainFilterField: 'nivel_id',
          mainValueToFilter: this.titulo.nivel.id
        }).subscribe((data) => {
          this.fields['caracter_id'].options = [...data];
          if(this.editComponente){
            this.editComponente.setFieldOptions('caracter_id', data);
          }
        });
        this.subscriptions.push(subCaracter);

        const subNivel = this.nivelService.getAllForSelect().subscribe((data) => {
          this.fields['nivel_id'].options = [...data];
        });
        this.subscriptions.push(subNivel);
      }
    });
  }
  reloadCaracterByNivel(option: { field: string, value: number }) {
    if (this.editComponente && option.field === 'nivel_id') {
      this.editComponente.clearField('caracter_id')
      this.fields['caracter_id'].options = [];
      const subCaracter = this.caracterService.getAllForSelect({
        ...defaultPaginateSelects,
        mainFilterField: 'nivel_id',
        mainValueToFilter: option.value
      }).subscribe((data) => {
        this.fields['caracter_id'].options = [...data];
        this.editComponente.setFieldOptions('caracter_id', data);
      });
      this.subscriptions.push(subCaracter);
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}

